module.exports = __webpack_public_path__ + "img/ES-J-13.0722bd1b.svg";